import { SelectOption } from "./SelectField";

export const mapSelectOptionsNormalizedValue = (options: any[]): SelectOption[] => options.map(x => {
    return {
        label: x.name,
        value: x.normalizedName.replace(/\s+/g, "_"),
        isDefault: x.default,
    }
}) ?? []

export const mapSelectOptionsIdValue = (options: any[]): SelectOption[] => options.map(x => ({
    label: x.name,
    value: x.id,
    isDefault: x.default,
})) ?? []